import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
    cardContainer: {
        marginBottom: '20px',
    },
}));
